import { Currency } from '@core/constants/data-types.constants';
import { CurrencyAmount } from './currency-amount.model';

export type CurrencyExchange = {
  [key: string]: {
    to: {
      [key2: string]: number;
    };
  };
};

export function convert(from: CurrencyAmount, to: Currency, currencyExchange: CurrencyExchange): CurrencyAmount {
  if (from.currency === to) {
    return from;
  }
  const ratio = currencyExchange[from.currency]?.to[to];
  if (ratio) {
    return {
      currency: to,
      amount: from.amount * ratio
    };
  }
  throw new Error(
    `Cannot convert from ${from.currency} to ${to} since there is no currency exchange available: ${JSON.stringify(
      currencyExchange
    )}`
  );
}

export function sum(
  currencyAmounts: CurrencyAmount[],
  to: Currency,
  currencyExchange: CurrencyExchange
): CurrencyAmount {
  let currencyAmount: CurrencyAmount = {
    amount: 0,
    currency: to
  };
  for (let ca of currencyAmounts) {
    ca = convert(ca, to, currencyExchange);
    currencyAmount = {
      ...currencyAmount,
      amount: currencyAmount.amount + ca.amount
    };
  }
  return currencyAmount;
}
